import { render, staticRenderFns } from "./music.vue?vue&type=template&id=239dbb54&scoped=true&"
import script from "./music.vue?vue&type=script&lang=js&"
export * from "./music.vue?vue&type=script&lang=js&"
import style0 from "./music.vue?vue&type=style&index=0&id=239dbb54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239dbb54",
  null
  
)

export default component.exports